/* RAVEXAN paket seçici ve teslimat zaman çizelgesi */
(function () {
  function bundleMessage(root) {
    var msg = root.querySelector('[data-rx-bundle-msg]');
    if (!msg) return;
    var msgText = msg.querySelector('[data-rx-bundle-msg-text]') || msg;
    var sel = root.querySelector('.rx-bundle__card.is-selected');
    var save = sel ? parseInt(sel.dataset.saveCents, 10) || 0 : 0;
    if (!sel || save <= 0) { msgText.textContent = ''; msg.hidden = true; return; }
    var strong = document.createElement('strong');
    strong.textContent = sel.dataset.save;
    msgText.textContent = '';
    msgText.appendChild(document.createTextNode('Bu pakette '));
    msgText.appendChild(strong);
    msgText.appendChild(document.createTextNode(' kazanıyorsun.'));
    msg.hidden = false;
    msg.classList.remove('is-changing');
    void msg.offsetWidth;
    msg.classList.add('is-changing');
  }

  // Sepete Ekle butonuna seçili paketin fiyatını ekler (Dawn'ın buton yazısına dokunmaz)
  function ctaButtons(root) {
    if (root.dataset.mode === 'bridge') {
      var section = root.closest('[id^="MainProduct-"]') || root.closest('.product') || document;
      return Array.prototype.slice.call(section.querySelectorAll('.product-form__submit'));
    }
    var form = root.closest('form');
    return form ? Array.prototype.slice.call(form.querySelectorAll('button[type="submit"]')) : [];
  }
  function updateCta(root) {
    var sel = root.querySelector('.rx-bundle__card.is-selected');
    if (!sel || !sel.dataset.price) return;
    ctaButtons(root).forEach(function (btn) {
      var el = btn.querySelector('.rx-cta__price');
      if (!el) {
        el = document.createElement('span');
        el.className = 'rx-cta__price';
        var first = btn.querySelector('span');
        if (first && first.nextSibling) btn.insertBefore(el, first.nextSibling);
        else btn.appendChild(el);
      }
      el.innerHTML = '· ' + sel.dataset.price;
    });
  }

  function select(root, card, fromUser) {
    var input = card.querySelector('.rx-bundle__input');
    if (!input || input.disabled) return;
    root.querySelectorAll('.rx-bundle__card').forEach(function (c) { c.classList.toggle('is-selected', c === card); });
    input.checked = true;
    bundleMessage(root);
    updateCta(root);

    if (root.dataset.mode === 'bridge') {
      // Dawn'ın gizli varyant seçicisindeki ilgili seçeneği tetikle
      var uid = root.dataset.uid;
      var i = card.dataset.index;
      var dawn = document.getElementById(uid + '-1-' + i);
      if (dawn && !dawn.checked) dawn.click();
    } else {
      // Vitrin: fiyatı güncelle
      var scope = root.closest('section') || document;
      var priceEl = scope.querySelector('[data-rx-price]');
      if (priceEl && card.dataset.price) priceEl.innerHTML = card.dataset.price;
    }
  }

  function initBundle(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    root.querySelectorAll('.rx-bundle__card').forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.preventDefault();
        select(root, card, true);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); select(root, card, true); }
      });
    });
    var start = root.querySelector('.rx-bundle__card.is-selected') || root.querySelector('.rx-bundle__card');
    if (start) {
      // Ürün sayfasında URL'de varyant yoksa varsayılan paketi Dawn'a da bildir
      if (root.dataset.mode === 'bridge' && !('hasUrlVariant' in root.dataset)) {
        select(root, start, false);
      } else {
        root.querySelectorAll('.rx-bundle__card').forEach(function (c) { c.classList.toggle('is-selected', c === start); });
        bundleMessage(root);
        updateCta(root);
      }
    }
  }

  var MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
  function addDays(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() + n); return x; }
  function fmt(d) { return d.getDate() + ' ' + MONTHS[d.getMonth()]; }
  function fmtRange(a, b) {
    if (a.getTime() === b.getTime()) return fmt(a);
    if (a.getMonth() === b.getMonth()) return a.getDate() + '–' + b.getDate() + ' ' + MONTHS[a.getMonth()];
    return fmt(a) + ' – ' + fmt(b);
  }

  function initDelivery(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var today = new Date();
    var ship = parseInt(root.dataset.ship, 10) || 1;
    var min = parseInt(root.dataset.min, 10) || 5;
    var max = parseInt(root.dataset.max, 10) || min;
    var set = function (sel, val) { var el = root.querySelector(sel); if (el) el.textContent = val; };
    set('[data-d-order]', fmt(today));
    set('[data-d-ship]', fmt(addDays(today, ship)));
    set('[data-d-deliver]', fmtRange(addDays(today, min), addDays(today, max)));
    root.hidden = false;
  }

  function initAll() {
    document.querySelectorAll('[data-rx-bundle]').forEach(initBundle);
    document.querySelectorAll('[data-rx-delivery]').forEach(initDelivery);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
